/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { translate } from 'react-i18next';

import AuthenticationStore from 'stores/AuthenticationStore';
import UserStore from 'stores/UserStore';
import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import LoginAsUserSuccess from './LoginAsUserSuccess';
import Loading from 'components/Loading/Loading';

type TypeProps = {|
  userStore: UserStore,
  authenticationStore: AuthenticationStore,
  actionDrawerStore: TypeActionDrawerStore,
|};

@translate()
@inject('actionDrawerStore', 'authenticationStore', 'userStore')
@observer
export default class LoginAsUserData extends React.Component<*> {
  componentDidMount() {
    const { actionDrawerStore, authenticationStore, userStore }: TypeProps = this.props;

    userStore.reloadingUser = true;
    authenticationStore.token.data = actionDrawerStore.response;
    authenticationStore.token.accessToken = actionDrawerStore.response.access_token;
    // authenticationStore.removeTokenFromLocal();
    localStorage.removeItem('token');
    authenticationStore.saveTokenToLocal();
    userStore.getActiveUser();

    //clear selectedUserImpersonate from User Management
    this.props.userStore.selectedUserImpersonate = null;
  }

  render(): React.Node {
    const { userStore }: TypeProps = this.props;

    return userStore.userLoaded ? <LoginAsUserSuccess /> : <Loading />;
  }
}
